import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';

const defaultTranslations: { [key: string]: string } = {
  'ngx-shared-due-to-inactivity': 'Due to inactivity,',
  'ngx-shared-minute': 'minute',
  'ngx-shared-minutes': 'minutes',
  'ngx-shared-remaining': 'remaining',
  'ngx-shared-second': 'second',
  'ngx-shared-seconds': 'seconds',
  'ngx-shared-you-have-been-logged-out': 'you have been logged out.',
  'ngx-shared-you-will-be-logged-out-automatically': 'you will be logged out automatically.',
  'ngx-shared-your-session-will-expire-in': 'Your session will expire in',
  'ngx-shared-close-dialog': 'close dialog',

  'ngx-shared-close-this-alert': 'Close this alert',
  'ngx-shared-important': 'Important',
  'ngx-shared-success': 'Success',
  'ngx-shared-warning': 'Warning',
  'ngx-shared-error': 'Error',

  'ngx-shared-menu-option': 'menu option',
  'ngx-shared-options': 'Options',
  'ngx-shared-search': 'Search',
  'ngx-shared-select-all': 'Select all',
  'ngx-shared-selected': 'selected',

  'ngx-shared-content-is-loading': 'Content is loading',
  'ngx-shared-please-wait-the-page-is-loading': 'Please wait, the page is loading.',

  'ngx-shared-of': 'of',

  'ngx-shared-off': 'off',
  'ngx-shared-on': 'on',
  'ngx-shared-switch': 'switch',

  'ngx-shared-instructions-toggle-tip': 'instructions toggle tip button',

  'ngx-shared-open-calendar': 'Open Calendar',

  'ngx-shared-page': 'Page',
  'ngx-shared-showing': 'Showing',
  'ngx-shared-results': 'results',
  'ngx-shared-page-changed-1': 'You\'re currently on Step 1 of 2: Content',
  'ngx-shared-page-changed-2': 'You\'re currently on Step 2 of 2: Settings',
  'ngx-shared-to': 'to',
  'ngx-shared-pager-ellipsis': 'horizontal ellipses',
};

export abstract class TranslateAdapter {
  language: string;
  abstract translate(key: string, context: any, language: string): Observable<string>;
}

@Injectable()
export class DefaultTranslateAdapter extends TranslateAdapter {
  language = 'en-us';

  translate(key: string, context: any, language: string): Observable<string> {
    const checkIfKeyExistsinDefaults = Object.keys(defaultTranslations).find((k) => k === key);

    if (!!checkIfKeyExistsinDefaults) {
      return new BehaviorSubject<string>(defaultTranslations[key]);
    }

    return new BehaviorSubject<string>(key);
  }
}

@Injectable()
export class TranslateService {

  constructor(private translateAdapter: TranslateAdapter) {}
  
  get language() {
    return this.translateAdapter.language;
  }

  translate(key: string, context?: { [k: string]: any }): Observable<string | undefined> {
    try {
      return this.translateAdapter.translate(key, context, this.language);
    } catch (err) {
      console.warn(`language: ${this.language}, key: ${key}, args:${JSON.stringify(context)}`);
      console.warn(err);
      return of(undefined);
    }
  }

}
